import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../styles/PolicyPages.css';

const ShippingPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1 className="policy-title">Shipping Policy</h1>
        <p className="policy-updated">Last updated: February 2025</p>

        <section className="policy-section">
          <h2>Free Shipping, Pan India</h2>
          <p>At QuitStick, we believe the first step toward quitting shouldn't cost extra. That's why we offer <strong>free shipping on every order</strong>, delivered anywhere across India — no minimum order value, no hidden charges.</p>
        </section>

        <section className="policy-section">
          <h2>Processing Time</h2>
          <p>All orders are processed within <strong>1–2 business days</strong> of being placed. Orders placed on weekends or public holidays will be processed on the next working day. Once your order is dispatched, you will receive a confirmation with your tracking details via email or SMS.</p>
        </section>

        <section className="policy-section">
          <h2>Delivery Time</h2>
          <p>Standard delivery across India typically takes <strong>4–7 business days</strong> depending on your location. Remote or rural areas may occasionally take up to 10 business days. We partner with trusted courier services to ensure your order reaches you safely and on time.</p>
        </section>

        <section className="policy-section">
          <h2>Order Tracking</h2>
          <p>Once your order has been shipped, you will receive a tracking number via the contact details provided at checkout. You can use this number to track your shipment directly on the courier's website.</p>
        </section>

        <section className="policy-section">
          <h2>Failed Delivery & Re-attempts</h2>
          <p>Our courier partners will attempt delivery up to <strong>3 times</strong> at the address provided. If delivery is unsuccessful after multiple attempts due to an incorrect address, incomplete address, or customer unavailability, the package will be marked as <strong>Return to Origin (RTO)</strong> and sent back to us.</p>
          <p>In such cases, a <strong>re-shipping fee will apply</strong> to dispatch the order again. We will contact you via email or phone to arrange re-delivery. QuitStick is not responsible for failed deliveries caused by incorrect address details provided at checkout. Please double-check your shipping address before confirming your order.</p>
        </section>

        <section className="policy-section">
          <h2>Shipping Restrictions</h2>
          <p>Currently, we ship only within India. We do not offer international shipping at this time.</p>
        </section>

        <section className="policy-section">
          <h2>Damaged or Lost Shipments</h2>
          <p>In the rare event that your package arrives damaged or is lost in transit, please contact us at <a href="mailto:support@quitstick.in">support@quitstick.in</a> within 48 hours of the expected delivery date. We will work with you and our courier partner to resolve the issue promptly.</p>
        </section>
      </div>
      
      <Footer />
    </div>
  );
};

export default ShippingPolicy;
